import { ENV } from "../Utils";
import { apiFetch } from "../Utils/apiFetch";

export class DidacticMaterialsAPI {
  baseApi = ENV.BASE_API;

  // 📌 Obtener materiales por región
  async getMaterialsByRegion(accessToken, region) {
    try {
      const url = `${this.baseApi}/didacticmaterials/region/${region}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await apiFetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en getMaterialsByRegion:", error);
      throw error;
    }
  }

  // 📌 Crear una nueva categoría en una región
  async createCategoryByRegion(accessToken, formData) {
    try {
      const url = `${this.baseApi}/didacticmaterials/createMaterialByRegion`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 201) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en createCategoryByRegion:", error);
      throw error;
    }
  }

  // 📌 Crear una subcategoría en una categoría dentro de una región
  async createSubcategoryByRegionAndCategory(accessToken, formData) {
    try {
      const url = `${this.baseApi}/didacticmaterials/createSubcategorieByRegionAndCategorie`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 201) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en createSubcategoryByRegionAndCategory:", error);
      throw error;
    }
  }

  // 📌 Actualizar una categoría en una región
  async updateCategoryByRegion(accessToken, formData) {
    try {
      const url = `${this.baseApi}/didacticmaterials/update/category`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en updateCategoryByRegion:", error);
      throw error;
    }
  }

  // 📌 Eliminar una categoría en una región
  async deleteCategoryByRegion(accessToken, data) {
    try {
      const url = `${this.baseApi}/didacticmaterials/delete/category`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en deleteCategoryByRegion:", error);
      throw error;
    }
  }

  // 📌 Eliminar una subcategoría en una región
  async deleteSubcategoryByRegion(accessToken, data) {
    try {
      const url = `${this.baseApi}/didacticmaterials/delete/subcategory`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) {
        throw new Error(result.message);
      }

      return result;
    } catch (error) {
      console.error("Error en deleteSubcategoryByRegion:", error);
      throw error;
    }
  }
}
